module.exports = __webpack_public_path__ + "static/media/sage_logo.3a5fabe6.png";